import {createTheme} from "@mui/material";
import {black} from "./colours/scheme";

const defaultHeader = {
    fontFamily: 'Kanit',
    fontWeight: "SemiBold"
}

export const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        background: {
            default: black,
            paper: black
        }
    },
    typography: {
        button: {
            fontFamily: 'Kanit',
            fontSize: '1.2rem',
            color: '#fff'
        },
        h2: defaultHeader,
        h5: defaultHeader,
        h6: defaultHeader,
    },
})

